module.exports = __webpack_public_path__ + "rijksoverheidsanstext-italic_2_0.woff?70d5c40913eb7ca8b5251c47e4ec0500";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/rijksoverheidsanstext-italic_2_0.woff
// module id = 546
// module chunks = 0